import styled from 'styled-components';
import tinyColor from 'tinycolor2';
import { getToken } from '@optimus-web/common';

interface ToggleContainerProps {
    visible?: boolean;
}

export const ToggleContainer = styled.button<ToggleContainerProps>`
    display: flex;
    align-items: center;
    cursor: pointer;
    background: transparent;
    border: 0;
    padding: 0;
    height: 24px;
    overflow: hidden;
    ${(props) => !props.visible && 'visibility: hidden;'}
    color: inherit;
`;

export const ContentContainer = styled.div`
    position: relative;
`;

interface GradientElementProps {
    lines: number;
    lineHeight: number;
    backgroundColor?: string;
}

export const GradientElement = styled.div<GradientElementProps>`
    display: inline-block;
    position: absolute;
    content: '';
    height: ${(props) => props.lineHeight}px;
    width: 100px;
    top: ${(props) => (props.lines - 1) * props.lineHeight}px;
    right: 0;
    background-image: ${({ backgroundColor: bgColorProp, theme }) => {
        const backgroundColor = bgColorProp || getToken('backgroundStaticFlat')({ theme });
        const startColor = tinyColor(backgroundColor).setAlpha(0).toRgbString();
        const endColor = tinyColor(backgroundColor).toRgbString();
        return `linear-gradient(to right, ${startColor}, ${endColor})`;
    }};
`;
